module.exports = function () {

    if ($('.topic-group-landing').length === 0) {
        return;
    }
        
    $('.topic-group-landing__show-more-description-toggle').click(function () {                
        $(this).addClass('topic-group-landing__show-more-description-toggle--hidden');

        var $container = $(this).closest('.topic-group-landing__title-container');
        if ($container.length) {           
            var $showMoreDescription = $container.find('.topic-group-landing__show-more-description');

            if ($showMoreDescription.length) {
                $showMoreDescription.removeClass('topic-group-landing__show-more-description--hidden');
            }
        }
        return false;
    });

    $('.topic-group-landing__show-less-description-toggle').click(function () {
        var $showMoreDescription = $(this).closest('.topic-group-landing__show-more-description');
        if ($showMoreDescription.length) {
            $showMoreDescription.addClass('topic-group-landing__show-more-description--hidden');
        }
        var $container = $(this).closest('.topic-group-landing__title-container');
        if ($container.length) {
            var $showMoreToggle = $container.find('.topic-group-landing__show-more-description-toggle');
            if ($showMoreToggle.length) {
                $showMoreToggle.removeClass('topic-group-landing__show-more-description-toggle--hidden');
            }
        }
        return false;
    });
};